//src/app/features/questionnaires/edit/routes/personal_details/the_basics.ts
import { BaseQuestionnaireRoute } from '../slice';

export type TheBasicsSubRoutes = {
  name: BaseQuestionnaireRoute;
  citizenship: BaseQuestionnaireRoute;
  past_fillings: BaseQuestionnaireRoute;
  family: BaseQuestionnaireRoute;
  dependents: BaseQuestionnaireRoute;
  // covid_relief: BaseQuestionnaireRoute;
  logistics: BaseQuestionnaireRoute;
};

export type TheBasicsRoutes = BaseQuestionnaireRoute & TheBasicsSubRoutes;

export const theBasicRoutes: { the_basics: TheBasicsRoutes } = {
  the_basics: {
    title: 'The Basics',
    path: 'the_basics',
    isValid: undefined,
    toggle: false,
    name: {
      title: 'Name',
      path: 'name',
      isValid: undefined,
    },
    citizenship: {
      title: 'Citizenship',
      path: 'citizenship',
      isValid: undefined,
    },
    past_fillings: {
      title: 'Past Filings',
      path: 'past_fillings',
      isValid: undefined,
    },
    family: {
      title: 'Spouse',
      path: 'family',
      isValid: undefined,
    },
    dependents: {
      title: 'Dependents',
      path: 'dependents',
      isValid: undefined,
    },
    // covid_relief: {
    //   title: 'COVID-19 Relief',
    //   path: 'covid_relief',
    //   isValid: undefined,
    // },
    logistics: {
      title: 'Logistics',
      path: 'logistics',
      isValid: undefined,
    },
  },
};
